import { useEffect } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import styled, { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';

import { AppRoutes } from './routes';
import { theme, scTheme } from './theme';
import { Notification } from 'components';
import { EventBusProvider } from 'hooks/useEventBus';
import PDFModal from 'components/PDFModal';
import Popup from 'components/Popup';

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  height: 30px;
  margin-top: -30px;
  width: 100%;
  color: ${({ theme }) => theme.colors[900]};
`;

export default function App(): JSX.Element {
  useEffect(() => {
    localStorage.removeItem('url');
  });

  useEffect(() => {
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <ThemeProvider theme={scTheme}>
        <EventBusProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Popup />
          <PDFModal />
        </EventBusProvider>
        <Notification />

        {location.pathname !== '/simulador-de-multas' && (
          <Footer>
            © Copyright 2020-{new Date().getFullYear()} - Daniel Law. All rights reserved.
          </Footer>
        )}
      </ThemeProvider>
    </ChakraProvider>
  );
}
